var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserEngagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.71111,
    y: 0.871465,
    width: 53.3137,
    height: 53.3137,
    rx: 26.6568,
    fill: "#F9F9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.71111,
    y: 0.871465,
    width: 53.3137,
    height: 53.3137,
    rx: 26.6568,
    stroke: "#EAEBF0",
    strokeWidth: 0.96934
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7694 32.2952C36.5569 33.4821 35.4358 35.8186 33.2865 35.8186H21.4495C19.3 35.8186 18.179 33.4821 19.9664 32.2952C22.0844 30.8887 24.6299 30.0688 27.3679 30.0688C30.106 30.0688 32.6514 30.8887 34.7694 32.2952Z",
    stroke: "black",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3679 27.5283C30.0207 27.5283 31.513 26.0361 31.513 23.3832C31.513 20.7304 30.0207 19.2381 27.3679 19.2381C24.715 19.2381 23.2228 20.7304 23.2228 23.3832C23.2228 26.0361 24.715 27.5283 27.3679 27.5283Z",
    stroke: "black",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEngagement);
export default __webpack_public_path__ + "static/media/user_engagement.79aa18ab6f197fe8c10f1b9964e4fd47.svg";
export { ForwardRef as ReactComponent };